import AirDatepicker from 'air-datepicker';
import Inputmask from 'inputmask';
import 'air-datepicker/air-datepicker.css';
import CellInput from '../NCellInput';
import './cellDatepicker.scss';
import { convertsDateToIsoFormat } from '../../../utils/utils';

export default class CellDatepicker extends CellInput {
    constructor($cell, options) {
        super($cell, options);
        this.datepicker = new AirDatepicker(this.$input, {
            onSelect: this.changesInput.bind(this),
            startDate: convertsDateToIsoFormat(this.$input.value),
            autoClose: true,
        });
        this.dataName = this.$cell.getAttribute('data-name');
        this.mask;
    }

    init() {
        this.mask = new Inputmask('99.99.9999', { showMaskOnHover: false }).mask(this.$input);
        // this.startCheck();
        !this.isRequired ? this.$cell.classList.add('js-no-required') : this.$cell.classList.remove('js-no-required');
        this.$input.addEventListener('input', this.changesInput.bind(this));
        this.$input.addEventListener('focus', this.focusInput.bind(this));
        this.$input.addEventListener('blur', this.blurInput.bind(this));
    }

    changesInput() {
        // !this.isInputError() ? this.successfulStatus() : this.removeSuccessfulStatus();
        // this.$input.value.length > 0 ? this.upLabel() : this.downLabel();
        this.removeErrorStatus();
        this.onChange ? this.onChange() : null;
        this.currentValue = this.$input.value;
    }

    isInputError(showError = false) {
        const isError = this.isRequired ? this.validateAge() : !this.mask.isComplete();
        // const isError = this.isRequired ? !this.mask.isComplete() : this.isRequired;

        if (showError && isError && this.isRequired) {
            this.errorStatus();
        }

        return isError;
    }

    validateAge() {
        if (this.dataName === 'DocumentDate' && this.currentValue.length === 0) {
            this.errorStatus('Поле обязательное для заполнения');
            return true;
        }

        if (this.dataName === 'DocumentDate' && this.currentValue.length !== 0) {
            const index = Number(this.tabIndex);
            let input = this.currentValue.match(/[0-9]+/g);
            let date = new Date(input[2], input[1] - 1, input[0]);
            let dateNow = new Date();
            let isInvalidDate = !(date.getFullYear() === parseInt(input[2], 10) && date.getDate() === parseInt(input[0], 10) && date.getMonth() === parseInt(input[1], 10) - 1);

            if (isInvalidDate) {
                this.$errorMessage.innerHTML = 'Неверный формат даты';
                return isInvalidDate;
            }
        }

        if (this.dataName === 'BirthDate' && this.currentValue.length !== 0) {
            const index = Number(this.tabIndex);
            let input = this.currentValue.match(/[0-9]+/g);
            let date = new Date(input[2], input[1] - 1, input[0]);
            let dateNow = new Date();
            let isInvalidDate = !(date.getFullYear() === parseInt(input[2], 10) && date.getDate() === parseInt(input[0], 10) && date.getMonth() === parseInt(input[1], 10) - 1);
            let originalDate = new Date(parseInt(input[2], 10), input[1] - 1, parseInt(input[0], 10));
            let originalDateWithoutOneDay = new Date(parseInt(input[2], 10), input[1] - 1, parseInt(input[0], 10));
            originalDateWithoutOneDay.setDate(originalDateWithoutOneDay.getDate() - 1);

            if (!isInvalidDate) {
                if (index === 0 || index === 1) {
                    if (date > dateNow) {
                        this.errorStatus('Дата рождения не может быть больше текущей даты');
                        return true;
                    } else if (originalDateWithoutOneDay >= this.getDataEnd(18)) {
                        this.errorStatus('Возраст должен быть не менее 18 лет');
                        return true;
                    } else if (originalDateWithoutOneDay <= this.getDataEnd(65)) {
                        this.errorStatus('Возраст должен быть не более 64 лет');
                        return true;
                    } else {
                        this.removeErrorStatus();
                        this.$errorMessage.textContent = 'Поле обязательное для заполнения';
                        return false;
                    }
                } else if (index === 2) {
                    if (date > dateNow) {
                        this.errorStatus('Дата рождения не может быть больше текущей даты');
                        return true;
                    } else if (originalDateWithoutOneDay >= this.getDataEnd(18)) {
                        this.errorStatus('Возраст должен быть не менее 65 лет');
                        return true;
                    } else if (originalDateWithoutOneDay >= this.getDataEnd(65)) {
                        this.errorStatus('Возраст должен быть не менее 65 лет');
                        return true; 
                    } else if (originalDateWithoutOneDay <= this.getDataEnd(74)) {
                        this.errorStatus('Возраст должен быть не более 73 лет');
                        return true;
                    } else {
                        this.removeErrorStatus();
                        this.$errorMessage.textContent = 'Поле обязательное для заполнения';
                        return false;
                    }
                }
            } else {
                this.$errorMessage.innerHTML = 'Неверный формат даты';
                return isInvalidDate;
            }
        } else if (this.dataName === 'BirthDate' && this.currentValue.length === 0) {
            this.$errorMessage.textContent = 'Поле обязательное для заполнения';
            return true;
        }
    }

    getDataEnd(end) {
        let currentDate = new Date();
        currentDate.setFullYear(currentDate.getFullYear() - end);
        return currentDate;
    }
}
